import { Layout } from 'antd'
import { FC, ReactNode, useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hook'
import {
    fetchConfig,
    fetchSeason,
    getProducts,
    setRewards,
} from '../../features/LeaderBoard/leaderBoardSlice'
import Styles from './layout.module.scss'

interface Props {
    children: ReactNode
    avatar?: string
    headerText?: string
    headerLogo?: string
    isSeasonHeaderHidden?: boolean
}
const { Content } = Layout
export const LeaderBoardLayout: FC<Props> = ({ children }) => {
    const { season, products } = useAppSelector((state) => state.leaderBoard)

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchConfig()).then(
            (response) => response.payload && dispatch(fetchSeason())
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!products?.length) {
            dispatch(getProducts())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [products])

    useEffect(() => {
        products && season && dispatch(setRewards({ products, season }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [products, season])

    return (
        <Layout
            className={Styles.container}
            style={{
                backgroundColor:
                    window.localStorage.getItem('TRANSPARENT') === 'transparent'
                        ? 'transparent'
                        : 'rgba(9, 10, 9, 1)',
            }}
        >
            <Content> {children}</Content>
        </Layout>
    )
}
